import { Header } from "./Header";
import Footer from "./Footer";
import "./PolicyPage.css";
import ContactUsPage from "./ContactUsPage";

const policyContent = {
  aboutus: {
    title: "About Us",
    sections: [
      {
        heading: "",
        text: "DocMaster is an innovative tech-solution for legal professionals in India. It is the only solution which plays multiple roles at one place for any advocate, be it meeting with a new client, researching on a case, drafting, online filing process or record management. You will find it helpful everywhere. To know more, register free and experience 45 days free trial offer.",
      },
      {
        heading: "Our Mission",
        text: "DocMaster aims to simplify writing a document and bridging the gaps in the process of written communication by innovation & technologies. We aim to deliver documents used within diverse industries including but not limited to real estate, education, utilities, banking and finance, insurance, human resources and legal. You name the document, we will make it.",
      },
      {
        heading: "Our Vision",
        text: "Revolutionising the correspondence world with simple language, grammar accuracy, subject matter clarity, technology and Innovation.",
      },
    ],
  },
  terms: {
    title: "1) Terms & Conditions",
    sections: [
      {
        heading: "License and Access",
        text: "DocMaster allows you a limited access to use its website subject to the terms and conditions mentioned on it, or as applicable and modified from time to time.",
      },
      {
        heading: "",
        text: "The website and any portion of it should not be reproduced, duplicated, copied, downloaded, sold, resold, or otherwise exploited for any commercial purpose without the express written consent of DocMaster. Any unauthorised use may be liable for termination of the services extended by the DocMaster.",
      },
      {
        heading: "Limitation of Liability",
        text: 'The website is for use "As is" and "As available" basis. DocMaster also makes, no representations or warranties of any kind, express or implied or otherwise stated, as to the operation of this site, or the information, content or materials included on this site. You expressly agree that your use of this site is at your sole choice and discretion.',
      },
      {
        heading: "Allowable usage",
        text: "You agree to use the services of DocMaster for lawful, personal or professional use of yourself or for particular business and client (as the case may be) only, and not for any prohibited purposes. Prohibited purposes include but shall not be limited to harass abuse or threaten any other persons, Violate any person's legal rights, violate any Intellectual Property Rights of DocMaster or any third party, publish or distribute any material unlawful, obscene or defamatory on the website, perpetrate any fraud and any other act prohibited by the law.",
      },
      {
        heading: "Voluntary Agreement of terms & conditions",
        text: "The user acknowledges that they have read the terms and conditions of the DocMaster and voluntarily in agreement without duress and with full knowledge of their legal significance. They also understand the functionalities and further changes with its software releases at later stages and are fully aware of the legal and binding effect of it.",
      },
      {
        heading: "Governing Law and Dispute Settlement",
        text: "All disputes arising out of these shall be governed by and construed in accordance with the laws of India. Any dispute arising out of or in connection with this shall be finally settled by the competent courts of New Delhi, India.",
      },
      {
        heading: "No Legal Relationship",
        text: "Nothing shall be construed to create an employer- employee, principal -client or any such relationship between user of the Website and DocMaster.",
      },
    ],
  },
  privacy: {
    title: "2) Privacy Policy",
    sections: [
      {
        heading: "Our Commitment to your Privacy",
        text: "DocMaster is committed towards protecting its user's privacy and ensuring that every visit to its website remains completely safe and secure.",
      },
      {
        heading: "",
        text: "In line with our commitment to transparency, this policy details what information is collected or processed by us, this privacy policy remains applicable to paid or free users.",
      },
      {
        heading: "Third Party",
        text: "Our website may contain links to third party websites. We are not responsible for the privacy policy or the practices of such third parties. This may include any payment gateway service portals or websites advertised on our platform. At all times, you are free to choose what information you share or save with these third parties without any notice to us.",
      },
      {
        heading: "",
        text: "We may however, collect, store and share aggregate and statistical data about user traffic, analytics or trends etc. without any specific reference.",
      },
      {
        heading: "",
        text: "We may partner with third party advertising networks, like well-known advertiser Google Adwords etc, to deal with our publicising on different platforms. Our website and advertising network may use cookies to gather non-personally identifiable information about your activities on this and other web destinations, to give you focused advertising depending on your interests. If you wish not to have this data utilised, you may quit by utilising the accompanying connections, for example, Google's Opt-out etc. or by setting your systems secure from such actions.",
      },
      {
        heading: "What Information We Collect",
        text: "We do not have a policy to collect users data, for the purpose of using it, for any purpose other than serving our users the desired services. Depending on the plans and usage choices of our subscribers both free and paid, we offer services where nothing is stored except in the enterprise or higher versions where users opt or need to use save and edit features of the modules.",
      },
      {
        heading: "Who we share your Personal Information with",
        text: "We do not sell, exchange or lease your name, contact details or any data to any other person. We may use some of the information which is generic or public in nature meant to generate statistical information or Artificial Intelligence or to improve product's experience, efficiency and productivity of our users.",
      },
      {
        heading: "",
        text: "Though the following paragraph stands null in normal circumstances but being added for general and for exceptional circumstances, that DocMaster would not deliver user's data of any nature to a third party with only exception, if it is legally necessary in line with the reporting standards of the Country, by a Court order, on a Court request, or Court summon. These are the information, generally financials, about the number regarding enlisted clients, number of interesting guests, and the pages most often perused.",
      },
      {
        heading: "Servers",
        text: "DocMaster uses cloud services on third party servers. We are committed to use the best of the methods to keep all the data and servers safe, and communicate in encrypted modes always. Multi layer security systems are deployed.",
      },
      {
        heading: "Usage and Privacy of Information",
        text: "The data you give when you prepare a document or perform an activity on our website, the same is held carefully classified or kept confidential.",
      },
    ],
  },
  ipr: {
    title: "3) IPR & Copyright",
    sections: [
      {
        heading: "",
        text: 'This Intellectual Property Rights (IPR) and Copyright Policy outlines how intellectual property, including copyrights, trademarks, and other proprietary rights are managed on DocMaster ("The Website"). By using "The Website", you acknowledge and agree to the terms outlined below.',
      },
      {
        heading: "Ownership of Intellectual Property",
        text: 'All content and materials available on DocMaster including but not limited to text, designs, graphics, logos, icons, software, documents, templates, and other resources (collectively, "Content"), are the exclusive property of DocMaster, its associates or its licensors unless otherwise expressly defined. The Contents of all types are protected by copyright, trademark, and other intellectual property laws.',
      },
      {
        heading: "",
        text: 'Except for the purpose and mutual written terms for the use of "The Website" subscribed, no one can reproduce, distribute, modify, display, perform, or transmit any content without the prior written permission of DocMaster or the respective intellectual property holders.',
      },
      {
        heading: "Copyright Infringement and DMCA Policy",
        text: 'DocMaster respects the intellectual property rights of others and expects our users to do the same. If you believe that any content on "The Website" infringes any one\'s copyright or intellectual property rights, you may submit a notification under the Digital Millennium Copyright Act (DMCA) or equivalent legislation. The team DocMaster will ensure to check the information and to take necessary corrective measures wherever required.',
      },
      {
        heading: "",
        text: "The notification such made to be sent to info@mydocmaster.inand must be in detail including identification of the material that is claimed to be infringing or the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate the material. Sender's contact information, including your name, address,",
      },
      {
        heading: "",
        text: "Upon receipt of notification, DocMaster will take appropriate steps within a period of 60 days.",
      },
      {
        heading: "Prohibitions to use Content",
        text: "Using any of the Content from DocMaster for commercial purposes, Creating derivative works from the Content. Distributing, reselling, or sublicensing the Content in any manner inconsistent with these Terms or applicable law without prior written consent are strictly prohibited.",
      },
      {
        heading: "Third-Party Intellectual Property",
        text: "DocMaster respects the intellectual property rights of all. The content available on the Website, if sourced from third-party creators or services, all efforts are made to attribute the content to its rightful owner and abide by the licensing terms. If you notice that any third-party intellectual property has been used without proper attribution or permission, please notify us immediately to help rectify the mistake.",
      },
      {
        heading: "Modifications to the Policy",
        text: 'DocMaster reserves the right to modify this IPR and Copyright Policy at any time. Any changes will be effective immediately upon posting to "The Website". It is your responsibility to review this policy periodically to remain informed about updates.',
      },
      {
        heading: "",
        text: "If you have any questions or concerns regarding this IPR and Copyright Policy, Please contact info@mydocmaster.in",
      },
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    sections: [
      {
        heading: "",
        text: 'The content available on DocMaster ("The Website") is for general informational purposes only. While the team DocMaster keeps on working to ensure that the content remains accurate and up-to-date to the best of their knowledge.',
      },
      {
        heading: "",
        text: "The use of \"The Website\" is at User's own risk in totality, as neither the DocMaster nor its associates makes any representations or warranties express or implied as it an expert's advice or view related to content published here. The user should use every information after verifying from their own sources or from legal experts.",
      },
      {
        heading: "No Legal Advice / No Legal Expert",
        text: 'All the features & services available at DocMaster like Quick Questionnaires with instant results, Documents, Templates, and various other resources are not intended to constitute advice or output from legal experts. DocMaster is not a law firm and does not offer legal representation. Any legal documents or information available on "The Website" are intended for general guidance only and should not be used as a substitute for professional legal counsel.',
      },
      {
        heading: "No Attorney-Client Relationship",
        text: 'Your use of DocMaster, including the completion of any process or templates, does not establish any nature of attorney-client relationship between you and DocMaster, its associates or its affiliates. Any use or communications made through "The Website" or its services do not create such a relationship.',
      },
      {
        heading: "Content or Document Accuracy",
        text: 'While we endeavor to make available to our users, accurate and useful legal information, templates and resources, we cannot guarantee that the documents or information on "The Website" will meet your specific needs or comply with the laws applicable to your jurisdiction. You are advised to cross check the outcomes as you are solely responsible for ensuring the documents and legal information available are appropriate for your situation and meet legal requirements.',
      },
      {
        heading: "Limitation of Liability",
        text: 'To the fullest extent permitted by law, DocMaster, its officers, employees, associates and affiliates disclaim all liability for any loss or damage arising to any user from the use of "The Website", its services, or reliance on any information or documents available therein. This includes, but is not limited to, direct, indirect, incidental, punitive, or consequential damages.',
      },
      {
        heading: "Third-Party Links",
        text: 'DocMaster may contain links to third-party websites or services that are not under its control. "The Website" does not endorse or assume any responsibility for the content, privacy policies, or practices of these third-party sites. Accessing third-party websites linked to DocMaster shall be at your own risks.',
      },
      {
        heading: "Changes to the Disclaimer",
        text: "DocMaster reserves the right to modify or update this Disclaimer Policy at any time without prior notice. Any changes will be effective immediately upon posting. It is your responsibility to review this Disclaimer periodically for any updates.",
      },
      {
        heading: "",
        text: "By continuing to use DocMaster, you acknowledge and agree to this Disclaimer Policy.",
      },
    ],
  },
  refund: {
    title: "4) Refund & Cancellation",
    sections: [
      {
        heading: "",
        text: "At DocMaster we aim to extend the best of the services to meet your professional requirements. We do not have any refund policy except as with only a few of the exceptions. One of them is technical. If you experience ongoing technical issues that prevent you from accessing the services and our support team is unable to resolve the problem within a reasonable time frame. The other is service disruption where a significant, extended disruption of services by DocMaster and you are unable to access your account for a prolonged period.",
      },
      {
        heading: "",
        text: "If you choose to cancel your subscription or downgrade your plan, no refunds or credits will be given for any unused portion of the subscription. You will have access to the services until the end of the billing period you paid for.",
      },
      {
        heading: "",
        text: "All refund requests are subject to review and approval by our team. If approved, the refund will be issued to the original payment method used.",
      },
      {
        heading: "Termination by DocMaster",
        text: "DocMaster reserves the right to suspend or terminate any account at any time if we suspect misuse of any nature including illegitimate use or violations of our Terms and Conditions. In such cases, no refunds will be eligible for the remaining subscription period.",
      },
    ],
  },
};

export default function PolicyPage({ type, title }) {
  const content = policyContent[type];
  const isBlank = !content;

  return (
    <div className="policy-page">
      <Header />
      <section className="policy-hero">
        <div className="policy-hero-overlay" />
        <div className="policy-hero-content">
          <h1>{title}</h1>
          {/* {type} */}
        </div>
      </section>
      <main className="policy-main">
        {
          <section className="policy-card">
            {!isBlank &&
              content.sections.map((item, index) => (
                <p key={`${type}-${index}`}>
                  {item.heading ? <strong>{item.heading} - </strong> : null}
                  {item.text}
                </p>
              ))}
            {type === "contactUs" && <ContactUsPage />}
          </section>
        }
      </main>
      <Footer />
    </div>
  );
}
